import classNames from "classnames";

import "./index.scss";

type Props = {
  title?: string | null;
  type?:
    | "primary"
    | "secondary"
    | "danger"
    | "warning"
    | "info"
    | "success"
    | "dark"
    | "disable";
  leftIcon?: string;
  rightIcon?: string;
  isOutline?: boolean;
  isLoading?: boolean;
  isDisable?: boolean;
  isSubmit?: boolean;
  onClick?: any;
  minWidth?: string;
};

const CustomButton2 = ({
  type = "primary",
  title,
  onClick,
  leftIcon,
  isDisable,
  rightIcon,
  isLoading,
  isOutline,
  isSubmit = false,
  minWidth,
}: Props) => {
  const styles = classNames(
    "button-wrapper",
    type && !isDisable ? type : "secondary",
    {
      disable: isDisable === true || isLoading === true,
      outLine: isOutline === true,
    }
  );

  return (
    <section
      style={{ minWidth: minWidth }}
      id="custom-button-container"
      onClick={
        isSubmit
          ? undefined
          : () => {
              if (!isDisable && !isLoading) onClick!(true);
            }
      }
    >
      <button className={styles} type={isSubmit ? "submit" : "button"}>
        {leftIcon && (
          <div className="icon">
            <i className={leftIcon} />
          </div>
        )}
        {title && (
          <div className="text">
            {isLoading && (
              <i
                className={classNames("fa-duotone fa-spinner", "loading-icon")}
              />
            )}
            <span className="button-text">{title}</span>
          </div>
        )}
        {rightIcon && (
          <div className="icon">
            <i className={rightIcon} />
          </div>
        )}
      </button>
    </section>
  );
};

export default CustomButton2;
